import { SuccessResponse } from '../request-response';
import { ResourceName } from '../resource-name';

export const InterviewGate = {
  resource: ResourceName.interview,
  actions: {
    launchInterview: 'launch-interview',
    launchFreeTrialInterview: 'launch-free-trial-interview',
    endInterview: 'end-interview',
    pingInterview: 'ping-interview',
  },
};

export type InterviewGateActionTypes = {
  launchInterview: {
    request: InterviewIdRequest;
    response: undefined;
  };
  launchFreeTrialInterview: {
    request: InterviewIdRequest;
    response: undefined;
  };
  endInterview: {
    request: InterviewIdRequest;
    response: undefined;
  };
  pingInterview: {
    request: InterviewIdRequest;
    response: SuccessResponse;
  };
};

export interface InterviewIdRequest {
  id: string;
}

export enum PingInterviewErrCodes {
  STATUS_NOT_ONGOING = 'STATUS_NOT_ONGOING',
  NO_START_TIME_STR = 'NO_START_TIME_STR',
  NO_CREDITS = 'NO_CREDITS',
  NOT_FOUND = 'NOT_FOUND',
}
